import { AdminBorrowerWithdrawalsFlexList } from '@react/admin/AdminBorrowerWithdrawalsFlexList'
import { SectionHeader } from '@react/components/common/SectionHeader'
import { useOtSelector } from '@react/redux/store'
import { REPORT_FETCH_DESCRIPTOR_WITHDRAW_EVENTS_ALL_LENDERS } from '@react/reporting/ReportDescriptors'
import ReportRowGenerator, { RefreshHandle } from '@react/reporting/ReportRowGenerator'
import { ETH_ADDR_ZERO, EthAddr } from '@shared/SchemaTypes'
import React, { useEffect, useRef } from 'react'

export const BorrowerWithdrawalFlexTab = (props: { poolAddr: EthAddr }): React.ReactElement => {
  const poolBaseOverviewCTO = useOtSelector(
    (state) => state.poolState.poolOverviewCTOs[props.poolAddr ?? ETH_ADDR_ZERO]
  )
  const reportRowGeneratorRef = useRef<RefreshHandle>(null)

  useEffect(() => {
    if (poolBaseOverviewCTO) {
      reportRowGeneratorRef.current?.doRefresh()
    }
  }, [poolBaseOverviewCTO])

  return (
    <>
      <AdminBorrowerWithdrawalsFlexList />
      <SectionHeader>Withdrawal Ledger</SectionHeader>
      <ReportRowGenerator
        ref={reportRowGeneratorRef}
        reportDescriptor={REPORT_FETCH_DESCRIPTOR_WITHDRAW_EVENTS_ALL_LENDERS}
        initialLoadWithoutRefresh={true}
        poolAddr={props.poolAddr}
      />
    </>
  )
}
